import { api } from "../../api-service/api";
import axios from "../../axios";
import {
  AUTH_ERROR,
  AUTH_FETCHING_DATA,
  AUTH_LOGIN,
  AUTH_LOGOUT,
  AUTH_REFRESH,
} from "../../typesAction";

export const login =
  (formProps: any, callback: any) => async (dispatch: any) => {
    try {
      dispatch({ type: AUTH_FETCHING_DATA, payload: true });

      /** @type any */
      const response = await axios.post(`/login_check`, formProps);
      if(response?.data){
        dispatch(saveTokens(response.data));
        callback();
      } else {
        dispatch({ type: AUTH_ERROR, payload: "Incorrect data." });
      }
    } catch (e) {
      dispatch({ type: AUTH_ERROR, payload: "Incorrect data." });
    }
  };

export const saveTokens = (data: any) => async (dispatch: any) => {
  localStorage.setItem("access_token", data.token);
  localStorage.setItem("permissions", JSON.stringify(data.permissions)); // Store user permissions [ ROLES ], we won't get them again on /api/token/refresh (reason: call is Anonymous on backend)
  axios.defaults.headers.Authorization = `Bearer ${data.token}`;
  localStorage.setItem("refresh_token", data.refresh_token);
  localStorage.setItem("isAuth", true.toString());

  api.setJwtToken(data.token);
  try {
    /** @type {{data: {aws_s3_client_id, aws_s3_client_secret, aws_s3_client_region, aws_s3_client_bucket}}} */
    const response2 = await axios.get(`/aws/s3`, {
      headers: { Authorization: "Bearer ".concat(data.token) },
    });

    localStorage.setItem("aws_s3_client_id", response2.data.aws_s3_client_id);
    localStorage.setItem(
      "aws_s3_client_secret",
      response2.data.aws_s3_client_secret
    );
    localStorage.setItem(
      "aws_s3_client_region",
      response2.data.aws_s3_client_region
    );
    localStorage.setItem(
      "aws_s3_client_bucket",
      response2.data.aws_s3_client_bucket
    );
  } catch (error) {
    console.error("Failed (not authorized) to acquire AWS credentials ", error);
  }

  // Call dispatch after storing the tokens in Redux
  dispatch({ type: AUTH_LOGIN, payload: data });
};

export const refreshToken =
  (refreshToken: any, callback?: any) => (dispatch: any) => {
    axios
      .post(`/token/refresh`, { refresh_token: refreshToken })
      .then((response: any) => {
        if (!!response.data) {
          const authToken = response.data.token;
          const refreshToken = response.data.refresh_token;
          localStorage.setItem("access_token", authToken);
          localStorage.setItem("refresh_token", refreshToken);
          localStorage.setItem("isAuth", true.toString());
          axios.defaults.headers.Authorization = `Bearer ${authToken}`;

          dispatch({
            type: AUTH_REFRESH,
            payload: {
              accessToken: authToken,
              refreshToken: refreshToken,
            },
          });
        }
      })
      .catch((err) => {
        logout();
      });

    if (!!callback) {
      callback();
    }
  };

export const logout = () => {
  console.info("Logout triggered, removing tokens and variables");

  localStorage.removeItem("aws_s3_client_id");
  localStorage.removeItem("aws_s3_client_secret");
  localStorage.removeItem("aws_s3_client_region");
  localStorage.removeItem("aws_s3_client_bucket");

  localStorage.removeItem("access_token");
  localStorage.removeItem("permissions");
  localStorage.removeItem("refresh_token");
  localStorage.removeItem("isAuth");
  localStorage.removeItem("selectedTenant");

  return {
    type: AUTH_LOGOUT,
    payload: null,
  };
};
